import React from 'react';

import {Button} from '@famly/mf_input_button';

type Props = {
    appendField: VoidFunction;
    text: string;
    disabled?: boolean;
};

const AppendField = ({appendField, text, disabled}: Props) => {
    return <Button text={text} icon={'add'} variant="transparent" onClick={appendField} isDisabled={disabled} />;
};

export {AppendField};
